import type { ProcessStage } from '../types/content';

export const processPhases = [
  { name: 'Define', stages: [0, 1], text: 'Agree what success looks like and how the search will reach it.' },
  { name: 'Discover', stages: [2, 3], text: 'Map the market and open confidential conversations with the right people.' },
  { name: 'Assess', stages: [4, 5, 6], text: 'Evaluate candidates rigorously and help you make a well-informed choice.' },
  { name: 'Appoint', stages: [7, 8, 9], text: 'Verify, agree terms and support a confident transition into the role.' },
];

export const processStages: ProcessStage[] = [
  {
    title: 'Discovery & briefing',
    description: 'We meet the key stakeholders to understand the organisation, the role, the culture and what success looks like.',
    outputs: ['Stakeholder conversations', 'Agreed objectives and timeline'],
  },
  {
    title: 'Search strategy & role definition',
    description: 'We translate the brief into a role specification, a success profile and a defined search strategy.',
    outputs: ['Role specification', 'Success profile and assessment criteria'],
  },
  {
    title: 'Talent mapping & market research',
    description: 'Our researchers map target organisations and identify relevant leaders across the market.',
    outputs: ['Target organisation list', 'Market map'],
  },
  {
    title: 'Candidate identification & outreach',
    description: 'We approach potential candidates discreetly and personally, introducing the opportunity with care.',
    outputs: ['Confidential approaches', 'Candidate interest log'],
  },
  {
    title: 'Screening & preliminary assessment',
    description: 'Interested candidates are interviewed in depth against the agreed success profile.',
    outputs: ['Structured interviews', 'Assessment notes'],
  },
  {
    title: 'Shortlisting & client presentation',
    description: 'We present a considered shortlist with detailed candidate reports and our honest perspective.',
    outputs: ['Shortlist report', 'Market feedback summary'],
  },
  {
    title: 'Interview coordination & feedback',
    description: 'We manage interview logistics and gather timely feedback from both sides.',
    outputs: ['Interview schedule', 'Two-way feedback'],
  },
  {
    title: 'References & due diligence',
    description: 'Where appropriate and with consent, we coordinate references and background checks.',
    outputs: ['Referencing', 'Verification checks'],
    conditional: true,
  },
  {
    title: 'Offer coordination & appointment',
    description: 'We help shape and negotiate offers so that both parties reach a confident agreement.',
    outputs: ['Offer guidance', 'Resignation and notice support'],
  },
  {
    title: 'Post-placement follow-up',
    description: 'Where included in the engagement, we stay in contact during the first months of the appointment.',
    outputs: ['Check-ins with client and appointee'],
    conditional: true,
  },
];
